import React from 'react';

import { cn } from 'lib/utils';
import { useServerNow } from 'shared/queries/serverTime';

import EventCountdown from './EventCountdown';

export default function NextEventCountdown(props: {
  eventId?: number | string | null;
  eventTimestamp?: number | string | null; // seconds, start of event
  endTimestamp?: number | null; // seconds, end of event (from ongoing API when available)
  /** If provided, LIVE label is shown only when true. Defaults to true. */
  liveReady?: boolean;
  /** When true, shows a pulsing 00:00 after event starts until LIVE becomes available. */
  pulseOnStarted?: boolean;
  className?: string;
}) {
  const { eventId, eventTimestamp, endTimestamp, liveReady = true, pulseOnStarted = false, className } = props;
  const baseClass = 'event-result-nextevent-countdown';
  const serverNow = useServerNow();
  const nowSec = Math.floor(serverNow / 1000);
  const startSec = eventTimestamp != null ? Number(eventTimestamp) : null;
  const endSec = endTimestamp != null && Number.isFinite(Number(endTimestamp)) ? Number(endTimestamp) : null;

  if (!eventId || startSec == null || !Number.isFinite(startSec)) {
    return (
      <div className={cn(baseClass, className)} data-event-id={eventId}>
        00:00
      </div>
    );
  }

  if (liveReady && endSec != null && nowSec >= startSec && nowSec < endSec) {
    return (
      <div
        className={cn(baseClass, className, 'inline-flex items-center gap-1 animate-pulse')}
        data-event-id={eventId}
      >
        <span className="inline-block rounded-full h-2 w-2 bg-red-500 shrink-0" aria-hidden />
        <span>LIVE</span>
      </div>
    );
  }

  // Countdown to event start only (no implicit LIVE fallback when endTimestamp is missing).
  // If the event already started but endTimestamp is unknown, show a stable placeholder.
  if (nowSec >= startSec) {
    return (
      <div
        className={cn(
          baseClass,
          className,
          pulseOnStarted ? 'inline-flex items-center gap-1 animate-pulse' : undefined
        )}
        data-event-id={eventId}
      >
        {pulseOnStarted ? (
          <>
            <span className="inline-block rounded-full h-2 w-2 bg-red-500 shrink-0" aria-hidden />
            <span>00:00</span>
          </>
        ) : (
          '00:00'
        )}
      </div>
    );
  }

  return (
    <div className={cn(baseClass, className)} data-event-id={eventId}>
      <EventCountdown
        targetMs={startSec * 1000}
        onComplete={() => {}}
        className={undefined}
      />
    </div>
  );
}

